var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultMyAccountAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 29V26H31V29H34V31H31V34H29V31H26V29H29ZM32 35V32H35V29H42L43.83 31H47C48.1 31 49 31.9 49 33V45C49 46.1 48.1 47 47 47H31C29.9 47 29 46.1 29 45V35H32ZM39 44C41.76 44 44 41.76 44 39C44 36.24 41.76 34 39 34C36.24 34 34 36.24 34 39C34 41.76 36.24 44 39 44ZM35.8 39C35.8 40.77 37.23 42.2 39 42.2C40.77 42.2 42.2 40.77 42.2 39C42.2 37.23 40.77 35.8 39 35.8C37.23 35.8 35.8 37.23 35.8 39Z",
    fill: "#6B717A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMyAccountAvatar);
export default __webpack_public_path__ + "static/media/DefaultMyAccountAvatar.2db7f868340b00b5fc2a38e510eaf5a0.svg";
export { ForwardRef as ReactComponent };